import { render, staticRenderFns } from "./VRBackground.vue?vue&type=template&id=c2d34554&scoped=true&"
import script from "./VRBackground.vue?vue&type=script&lang=js&"
export * from "./VRBackground.vue?vue&type=script&lang=js&"
import style0 from "./VRBackground.vue?vue&type=style&index=0&id=c2d34554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d34554",
  null
  
)

component.options.__file = "VRBackground.vue"
export default component.exports